/**
 * JWNET未加入業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/non_subscribe_traders`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      code: null,
      name: null,
      subscriber_type: null,
      location_name: null,
      unregister_location: null,
    },
  }
}
const non_subscribe_trader = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     *
     * @param dispatch
     * @param commit
     * @param state
     * @param code
     * @param name
     * @param subscriber_type
     * @param location_name
     * @param unregister_location
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { code, name, subscriber_type, location_name, unregister_location, page, limit, format }) {
      let api_path
      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      dispatch('saveCondition', { code: code, name: name, subscriber_type: subscriber_type, location_name: location_name, unregister_location: unregister_location, limit: limit})
      const params = { 
        code: state.condition.code, 
        name: state.condition.name, 
        subscriber_type: state.condition.subscriber_type, 
        location_name: state.condition.location_name, 
        unregister_location: state.condition.unregister_location, 
        limit: state.condition.limit, 
        page: page 
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if ((format != 'csv')) {
            let content = data.content
            commit(types.DRIVER_NON_SUBSCRIBE_TRADER, { content })
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { code, name, subscriber_type, location_name, unregister_location, limit }) {
      const _code = (code !== undefined) ? code : state.condition.code
      const _name = (name !== undefined) ? name : state.condition.name
      const _subscriber_type = (subscriber_type !== undefined) ? subscriber_type : state.subscriber_type
      const _location_name = (location_name !== undefined) ? location_name : state.location_name
      const _unregister_location = (unregister_location !== undefined) ? unregister_location : state.unregister_location
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = { code: _code, name: _name, subscriber_type: _subscriber_type, location_name: _location_name, unregister_location: _unregister_location, limit: _limit }
      commit(types.DRIVER_NON_SUBSCRIBE_TRADER_CONDITION, { params })
    },
    resetState({ commit }) {
      commit(types.DRIVER_NON_SUBSCRIBE_TRADER_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_NON_SUBSCRIBE_TRADER_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_NON_SUBSCRIBE_TRADER_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_NON_SUBSCRIBE_TRADER_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_NON_SUBSCRIBE_TRADER] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_NON_SUBSCRIBE_TRADER_CONDITION] (state, { params }) {
      state.condition.code = params.code
      state.condition.name = params.name
      state.condition.subscriber_type = params.subscriber_type
      state.condition.location_name = params.location_name
      state.condition.unregister_location = params.unregister_location
      state.condition.limit = params.limit
    }
  },
}

export default non_subscribe_trader
